(() => {
  const today = () => {
    const d = new Date();
    return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
  };
  function setup(parent) {
    const form = parent.querySelector('form');
    if (!form || form.dataset.rentalReady) return;
    form.dataset.rentalReady = 'true';
    const dateId = 'RentalDate-' + form.getAttribute('id');
    const field = document.createElement('div');
    field.className = 'product-form__input';
    const label = document.createElement('label');
    label.htmlFor = dateId;
    label.className = 'form__label';
    label.textContent = parent.dataset.rentalDateLabel;
    const date = document.createElement('input');
    date.id = dateId;
    date.type = 'date';
    date.name = 'properties[Preferred Delivery Date]';
    date.min = today();
    date.required = true;
    date.className = 'field__input';
    date.style.cssText = 'width:100%;border:1px solid #9caec4;border-radius:6px;padding:12px;background:white;color:#003366;';
    field.append(label, date);
    const note = document.createElement('p');
    note.className = 'caption-large';
    note.textContent = parent.dataset.rentalNote;
    const buttons = form.querySelector('.product-form__buttons');
    buttons.before(field, note);
    const rental = document.createElement('input');
    rental.type = 'hidden'; rental.name = 'properties[Rental Item]'; rental.value = 'Yes';
    const duration = document.createElement('input');
    duration.type = 'hidden'; duration.name = 'properties[Rental Duration]';
    form.append(rental, duration);
    if (parent.dataset.requiresBedDelivery === 'true') {
      const service = document.createElement('input');
      service.type = 'hidden'; service.name = 'properties[Required Service]';
      service.value = 'Calmedi delivery, setup and return collection — $250 included and paid upfront'; form.append(service);
    }
    const update = () => {
      const selected = parent.closest('product-info')?.querySelector('variant-selects [data-selected-variant]');
      try { duration.value = selected ? JSON.parse(selected.textContent).title : ''; } catch { duration.value = ''; }
    };
    form.querySelector('[name="id"]').addEventListener('change', update);
    form.addEventListener('submit', event => {
      if (!date.checkValidity() || date.value < today()) {
        event.preventDefault(); event.stopImmediatePropagation(); date.reportValidity(); date.focus();
      }
    }, true);
    update();
  }
  function setupStandalone(form) {
    if (form.dataset.rentalReady) return;
    form.dataset.rentalReady = 'true';
    const select = form.querySelector('[name="id"]');
    const date = form.querySelector('[type="date"]');
    const price = form.querySelector('[data-rental-price]');
    const duration = form.querySelector('[name="properties[Rental Duration]"]');
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-rental-status]');
    date.min = today();
    const sync = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price;
      duration.value = option.textContent.trim();
      button.disabled = option.dataset.available !== 'true';
      status.textContent = button.disabled ? form.dataset.unavailable : '';
    };
    select.addEventListener('change', sync);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || date.value < today()) return;
      button.disabled = true;
      button.textContent = form.dataset.adding;
      status.textContent = '';
      try {
        const action = new URL(form.action);
        action.pathname = action.pathname.replace(/\/add$/, '/add.js');
        const data = new FormData(form);
        const sheet = form.querySelector('[data-calmedi-sheet-addon]:checked');
        const headers = {Accept:'application/json'};
        let body = data;
        if (sheet) {
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) properties[match[1]] = value;
          }
          body = JSON.stringify({items:[
            {id:data.get('id'),quantity:Number(data.get('quantity') || 1),properties},
            {id:sheet.value,quantity:1}
          ]});
          headers['Content-Type'] = 'application/json';
        }
        const response = await fetch(action, {method:'POST', body, headers});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        status.textContent = error.message || form.dataset.error;
        button.disabled = false;
        button.textContent = form.dataset.cta;
      }
    });
    sync();
  }
  function init() {
    document.querySelectorAll('product-form[data-is-rental="true"]').forEach(setup);
    document.querySelectorAll('form[data-calmedi-rental-form]').forEach(setupStandalone);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
